<template>
    <div id="topbar">
        <h4>
            <span id="sidebarx" class="glyphicon glyphicon-menu-hamburger" @click="handleSidebarxClicked"></span>
            &nbsp;
            {{title}}
        </h4>
        <h4 v-if="hasKeymap">
            <router-link :to="{name: 'converter-keymap', params:{version:version}}">
                <button class="btn btn-default">
                    <i class="fa fa-book fa-fw"></i>Keymap
                </button>
            </router-link>
        </h4>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'Topbar',
    props: {
        title: String,
        hasKeymap: Boolean
    },
    computed: {
        ...mapState({
            version: state => {
                return state.phonetic.version;
            }
        })
    },
    methods: {
        handleSidebarxClicked () {
            this.$store.commit('sidebar/TOGGLE_SIDEBAR');
        }
    }
};
</script>
